import React from 'react';
import ProductPage from '../components/product/ProductPage';
import { personalPrizeConfig } from '../config/products';

const PersonalPrizePage: React.FC = () => {
  return <ProductPage config={personalPrizeConfig} />;
};

export default PersonalPrizePage;

